import { WireActions, WireApiActions } from '@discover/store/actions/discover.actions';
import { DiscoverState } from '@discover/store/models/discover.models';
import { createReducer, on } from '@ngrx/store';

export const initialState: DiscoverState = {
    wires: [],
    isLoading: false,
    topics: new Map<string, StorytellingTopicRecord>(),
    storedViewStates: null,
    currentSelectedViewState: null,
    isAttachToTopicListLoading: false,
};

export const wiresReducer = createReducer(
    initialState,
    on(WireApiActions.stopPolling, (): DiscoverState => {
        return initialState;
    }),
    on(WireActions.loading, (state, action): DiscoverState => {
        return {
            ...state,
            isLoading: action.isLoading,
        };
    }),
    on(WireApiActions.startPolling, (state): DiscoverState => {
        return {
            ...state,
            isLoading: true,
        };
    }),
    on(WireApiActions.loadWiresSuccess, WireApiActions.loadWiresError, (state): DiscoverState => {
        return {
            ...state,
            isLoading: false,
        };
    }),
    on(WireApiActions.loadTopicsSuccess, (state, { topics }): DiscoverState => {
        return {
            ...state,
            topics,
        };
    }),
    on(WireApiActions.loadWiresSuccess, (state, { wires }) => {
        return {
            ...state,
            wires: [
                ...state.wires,
                ...wires.filter(wire => {
                    return !state.wires.find(item => item.Guid === wire.Guid);
                }),
            ],
        };
    }),
    on(WireActions.openImage, (state, { image }): DiscoverState => {
        return { ...state, selectedImage: image };
    }),

    on(WireActions.addWire, (state, wire) => {
        if (state.wires.find(item => item.Guid === wire.Guid)) {
            return state;
        }
        return { ...state, wires: [...state.wires, wire] };
    }),
    on(WireApiActions.createTopic, (state): DiscoverState => {
        return { ...state, isLoading: true };
    }),
    on(WireActions.openNewTopicFromWire, (state): DiscoverState => {
        return { ...state, isLoading: false };
    }),
    on(WireApiActions.loadTopicViewStatesSuccess, (state, { data }): DiscoverState => {
        return {
            ...state,
            storedViewStates: data,
        };
    }),
    on(WireActions.setCurrentTopicViewState, (state, { viewState }): DiscoverState => {
        return {
            ...state,
            currentSelectedViewState: state?.storedViewStates?.views?.find(view => view.guid === viewState.guid) || null,
        };
    }),
    on(WireApiActions.attachItem, (state): DiscoverState => {
        return { ...state, isAttachToTopicListLoading: true };
    }),
    on(WireApiActions.attachItemSuccess, (state): DiscoverState => {
        return { ...state, isAttachToTopicListLoading: false };
    })
);
